import React, {useState} from 'react'
import classnames from "classnames";

import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import Box from "@mui/material/Box";
import Switch from "@mui/material/Switch";
import {useDealContext} from "../../contexts/DealContext";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import useDidMountEffect from "../../hooks/useDidMountEffect";
import TableHead from "@mui/material/TableHead";
import Collapse from "@mui/material/Collapse";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import {NumericFormat} from "react-number-format";
import {DealPageFee} from "./DealPageFee";
import {DealPageCreateCustomFee} from "./DisclosurePDFs/components/DealPageCreateCustomFee";


export const DealPageFees = () => {
    const { setDealStateWithUpdate, updateDealResponse, dealState } = useDealContext()
    const [open, setOpen] = useState(false);

    const fees = dealState.formatted_quote.fees.filter((f) => {
        if (f.name === 'Registration Fee') return true;
        if (f.name === 'Acquisition Fee') return true;
        if (f.name === 'Doc Fee') return true;
        return f.amount !== '0'
    })
    const [isAllFinanced, setIsAllFinanced] = useState(fees.every(f => f.is_capped === true))

    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })

    useDidMountEffect(function setAllFees(){
        let newDealState = structuredClone(dealState)
        const fees = newDealState.formatted_quote.fees

        const newFees = []

        fees.forEach((el, index, array) => {
            const newEl = structuredClone(el)
            newEl.is_capped = isAllFinanced

            newFees.push(newEl)
        })

        newDealState.formatted_quote.fees = newFees
        setDealStateWithUpdate(newDealState, true)
    }, [isAllFinanced])

    if (!(dealState && dealState?.formatted_quote)) return null;

    const isLoading = updateDealResponse?.loading

    const totalFeeAmount = fees.reduce(function(accumulator, fee) {
        return accumulator + Number(fee.amount);
    }, 0)

    return (
        <Box className={classnames("dealPageFees", {
            mobile: isTabletOrMobile
        })}>
            <Stack
                direction={'row'}
                justifyContent="space-between"
                alignItems="center"
                className={'header header-row'}
            >
                <div
                    className={'header-name'}
                >
                    Fees
                </div>
                <Stack
                    direction={'row'}
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <div className={'header-amount'}>
                        <NumericFormat
                            value={totalFeeAmount}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                        />
                    </div>
                    <div>
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => setOpen(!open)}
                        >
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </div>
                </Stack>
            </Stack>
                <Collapse in={open} timeout="auto" mountOnEnter={true}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    className={'header-cell'}
                                    align="left"
                                    width={isTabletOrMobile ? '60%' : '40%'}
                                >
                                    Name
                                </TableCell>
                                <TableCell
                                    className={'header-cell'}
                                    align="right"
                                    width={'30%'}
                                >
                                    { isTabletOrMobile ? "" : "Capped"}
                                    <Switch
                                        label="Label"
                                        disabled={isLoading}
                                        checked={isAllFinanced}
                                        onChange={() => {
                                            setIsAllFinanced(!isAllFinanced)
                                        }}
                                    />
                                </TableCell>

                                <TableCell
                                    className={'header-cell'}
                                    align="right"
                                    width={isTabletOrMobile ? '40%' : '25%'}
                                >
                                    Amount
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <DealPageCreateCustomFee
                                isTabletOrMobile={isTabletOrMobile}
                                dealState={dealState}
                                isLoading={isLoading}
                                setDealStateWithUpdate={setDealStateWithUpdate}
                            />
                            {
                                fees.map((fee, idx) => {
                                    return (
                                        <DealPageFee
                                            isTabletOrMobile={isTabletOrMobile}
                                            key={fee.id}
                                            dealState={dealState}
                                            fee={fee}
                                            isLoading={isLoading}
                                            setDealStateWithUpdate={setDealStateWithUpdate}
                                        />
                                    )
                                })
                            }
                        </TableBody>
                    </Table>
            </Collapse>
        </Box>
    )
}